<div bsModal #staticModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-static"
     [config]="{backdrop: 'static'}" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 id="dialog-static" class="modal-title pull-left">
                    Assign Photos to {{ 'Component' | terminology | async }}
                </h4>
                <button type="button" class="close pull-right" (click)="closeModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="medium-padding remove-margin">

                    <!-- <p><strong>{{ selectedPhotoCount }} photos selected</strong></p> -->
                    <p>Use the search box below to find the {{ 'component' | terminology | async }} associated with the selected photos or check the option to unassign if no {{ 'component' | terminology | async }} should be associated.</p>

                    <div [hidden]="unassignFromComponents">
                        <sp-typeahead-property-component
                            #componentTypeahead
                            [selectedPropertyId]="propertyId"
                            [selectedFiscalYear]="fiscalYear?.year"
                            (componentSelected)="setSelectedComponent($event)"
                        ></sp-typeahead-property-component>
                    </div>
                    <div [hidden]="!unassignFromComponents" class="form-control unassigned-msg">
                        No component - Photos will be unassigned
                    </div>

                    <div class="margin-top-20">
                        <input name="unassignFromComponent" id="unassignFromComponent" type="checkbox" [checked]="unassignFromComponents" (click)="toggleUnassign()" />
                         <label for="unassignFromComponent">Unassign photos from {{ 'components' | terminology | async }}</label>
                    </div>
                </div>
            </div>
            <footer class="text-start">
                <button type="button" class="btn btn-cancel" (click)="closeModal()">Cancel</button>
                <button type="button" class="btn btn-success" [disabled]="!selectedComponent && !unassignFromComponents" (click)="assignComponent()">Assign</button>
            </footer>
        </div>
    </div>
</div>
